import { render, staticRenderFns } from "./PlansV3.vue?vue&type=template&id=361c5442&"
import script from "./PlansV3.vue?vue&type=script&lang=js&"
export * from "./PlansV3.vue?vue&type=script&lang=js&"
import style0 from "./PlansV3.vue?vue&type=style&index=0&id=361c5442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports